import { useDepositIncomingContext } from '@/contexts/DepositIncomingContext';
import { DepositIncomingCardView } from './DepositIncomingCardView';

// CustomerTemplateManager의 그리드(grid-cols-1 gap-3) 안 slot으로 주입되므로
// 자체 래퍼 없이 fragment로 카드들을 직접 내보낸다(기존 DepositIncomingPanel과 동일 규약).
// 참고 후보(회색 카드)는 /deposits 전용 — /order 노출은 오너 결정(D8, 2026-07-06)으로 제거
// (과거 정산서를 가리키는 카드가 그 날짜 작업 화면에 얹히는 것 반대).
export function DepositFallbackCards() {
  const { fallbackCards, confirm, reject, undo, confirming, justArrivedMatchIds, confirmedMatchIds } = useDepositIncomingContext();
  if (fallbackCards.length === 0) return null;
  return (
    <>
      {fallbackCards.map((card) => (
        <DepositIncomingCardView
          key={card.matchId}
          card={card}
          onConfirm={confirm}
          onReject={reject}
          onUndo={undo}
          confirming={confirming}
          justArrived={justArrivedMatchIds.has(card.matchId)}
          confirmed={confirmedMatchIds.has(card.matchId)}
        />
      ))}
    </>
  );
}
